// Intro splash: shows once per browser session, then fades out at 3 seconds.
// No per-frame work: one timer plus a compositor opacity fade, and a hard timer removal
// so the site always opens even where animations are paused.
const STORAGE_KEY = 'heaven-splash-seen';
const TOTAL_MS = 3000;
const FADE_MS = 500;

class SplashElement extends HTMLElement {
  connectedCallback() {
    let seen = false;
    try {
      seen = sessionStorage.getItem(STORAGE_KEY) === '1';
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      seen = false;
    }
    if (seen || location.search.includes('splash=off')) {
      this.finish();
      return;
    }

    document.documentElement.style.overflow = 'hidden';
    this.slideTracks();
    this.fadeTimer = setTimeout(() => {
      if (typeof this.animate === 'function') {
        this.animate([{ opacity: 1 }, { opacity: 0 }], { duration: FADE_MS, easing: 'ease-out', fill: 'forwards' });
      }
    }, TOTAL_MS - FADE_MS);
    this.removeTimer = setTimeout(() => this.finish(), TOTAL_MS);
  }

  disconnectedCallback() {
    clearTimeout(this.fadeTimer);
    clearTimeout(this.removeTimer);
    document.documentElement.style.overflow = '';
  }

  // Each track holds its product list twice, so sliding left by half its width loops seamlessly.
  // Direction follows reading order: leftward in LTR, rightward in RTL.
  slideTracks() {
    if (typeof this.animate !== 'function') return;
    const direction = document.documentElement.dir === 'rtl' ? 1 : -1;
    for (const track of this.querySelectorAll('[data-splash-track]')) {
      const halfWidth = track.scrollWidth / 2;
      const speed = Number(track.dataset.splashSpeed) || 60;
      if (!halfWidth) continue;
      track.animate(
        [{ transform: 'translate3d(0, 0, 0)' }, { transform: `translate3d(${direction * halfWidth}px, 0, 0)` }],
        { duration: (halfWidth / speed) * 1000, iterations: Infinity, easing: 'linear' },
      );
    }
  }

  finish() {
    document.documentElement.classList.add('splash-seen');
    document.documentElement.style.overflow = '';
    this.remove();
  }
}

if (!customElements.get('s-splash')) {
  customElements.define('s-splash', SplashElement);
}
